export default "__VITE_ASSET__2qjtkefQ__"